import { ActionContext } from 'vuex'
import apiMission from '@/api/mission'
import apiAdminAdminFleet from '@/api/admin/adminFleet'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import { IRootState } from '@/store'
import { IUiState } from './state'
import { AloMission } from '@/models/alo/AloMission'
import { ApiResultCode } from '@/models/response/AlrBase'
import { ConsoleRow } from '@/models/ui/ConsoleRow'
import { Coordinate } from 'ol/coordinate'
import { Feature } from 'ol'
import { ZoomTransform } from 'd3'
import { HoverData } from '@/models/ui/HoverData'
import { GraphUiState } from '@/models/ui/GraphUiState'
import { LayerConfig } from '@/models/ui/LayerConfig'
import { SoundNotification } from '@/enum/SoundNotification'
import { SimulationUiState } from '@/models/ui/SimulationUiState'
import { IMissionState } from '../mission/state'
import { AloLogbookChannel } from '@/models/alo/AloLogbookChannel'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'

export class UiAction {
  public [types.UI_CLOSE_SNACKBAR](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>(resolve => {
      context.commit(types.UI_CLOSE_SNACKBAR)
      resolve()
    })
  }
  public [types.UI_ADD_SNACK_MESSAGE](context: ActionContext<IUiState, IRootState>, message: string) {
    return new Promise<void>(resolve => {
      context.commit(types.UI_ADD_SNACK_MESSAGE, message)
      resolve()
    })
  }
  public [types.UI_SET_REDIRECT_PATH](context: ActionContext<IUiState, IRootState>, path: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_REDIRECT_PATH, path)
      resolve()
    })
  }
  public [types.UI_TOGGLE_DARKMODE](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      //console.log("UI_TOGGLE_DARKMODE")
      context.commit(types.UI_TOGGLE_DARKMODE)
      resolve()
    })
  }
  public [types.UI_SET_SOUND_NOTIFICATION](
    context: ActionContext<IUiState, IRootState>,
    soundNotification: SoundNotification,
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_SOUND_NOTIFICATION, soundNotification)
      resolve()
    })
  }
  public [types.UI_TOGGLE_GDB_CONSOLE_FILTER](
    context: ActionContext<IUiState, IRootState>,
    { gdbType, uiid }: { gdbType: string; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_GDB_CONSOLE_FILTER, { gdbType, uiid })
      resolve()
    })
  }
  public [types.UI_SET_GDB_CONSOLE_FILTER](
    context: ActionContext<IUiState, IRootState>,
    { gdbTypes, uiid }: { gdbTypes: Array<string>; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GDB_CONSOLE_FILTER, { gdbTypes, uiid })
      resolve()
    })
  }
  public [types.UI_SET_CONSOLE_AUTOSCROLL](
    context: ActionContext<IUiState, IRootState>,
    { autoScroll, uiid }: { autoScroll: boolean; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_CONSOLE_AUTOSCROLL, { autoScroll, uiid })
      resolve()
    })
  }

  public [types.UI_SET_CONSOLE_SCROLLINDEX](
    context: ActionContext<IUiState, IRootState>,
    { index, uiid }: { index: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_CONSOLE_SCROLLINDEX, { index, uiid })
      resolve()
    })
  }

  public [types.UI_RESET_SMARTPLANNING_FILTER](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_RESET_SMARTPLANNING_FILTER)
      resolve()
    })
  }
  public [types.UI_TOGGLE_DRAWER_VISIBILITY](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_DRAWER_VISIBILITY)
      resolve()
    })
  }
  public [types.UI_SET_DRAWER_VISIBILITY](context: ActionContext<IUiState, IRootState>, isVisible: boolean) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_DRAWER_VISIBILITY, isVisible)
      resolve()
    })
  }
  public [types.UI_TOGGLE_RIGHT_DRAWER_VISIBILITY](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_RIGHT_DRAWER_VISIBILITY)
      resolve()
    })
  }
  public [types.UI_SET_RIGHT_DRAWER_VISIBILITY](context: ActionContext<IUiState, IRootState>, isVisible: boolean) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_RIGHT_DRAWER_VISIBILITY, isVisible)
      resolve()
    })
  }
  public [types.UI_TOGGLE_MISSION_MAP_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    { missionId, uiid }: { missionId: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MISSION_MAP_VISIBILITY, { missionId, uiid })
      resolve()
    })
  }
  public [types.UI_SET_MISSION_MAP_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    { missionId, uiid, visible }: { missionId: number; uiid: string; visible: boolean },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_MISSION_MAP_VISIBILITY, { missionId, uiid, visible })
      resolve()
    })
  }
  public [types.UI_SHOW_ALL_SIMULATION_MISSION_MAP](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      if (uiid == 'map_global') {
        // BLF037 — scénarios autorisés pour leur enseigne seulement (RG-ACC-050).
        const newSimulationMapVisibility = context.rootGetters.smartScenarios
          //@ts-ignore
          .map(m => m.id)
          //@ts-ignore
          .reduce((a, simId) => {
            a[simId] = true
            return a
          }, {} as { [id: number]: boolean })
        context.commit(types.UI_SHOW_ALL_SIMULATION_MISSION_MAP, newSimulationMapVisibility)
      } else {
        const newMissionMapVisibility = (
          context.rootGetters.modifiedAdmMissionGlobal.misIdArray as Array<number>
        ).reduce((a, misId) => {
          a[misId] = true
          return a
        }, {} as { [id: number]: boolean })
        context.commit(types.UI_SHOW_ALL_DRAWER_MISSION_MAP, { newMissionMapVisibility, uiid: '' })
      }
      resolve()
    })
  }
  public [types.UI_HIDE_ALL_SIMULATION_MISSION_MAP](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      if (uiid == 'map_global') {
        // BLF037 — scénarios autorisés pour leur enseigne seulement (RG-ACC-050).
        const newSimulationMapVisibility = context.rootGetters.smartScenarios
          //@ts-ignore
          .map(m => m.id)
          //@ts-ignore
          .reduce((a, simId) => {
            a[simId] = false
            return a
          }, {} as { [id: number]: boolean })
        context.commit(types.UI_HIDE_ALL_SIMULATION_MISSION_MAP, newSimulationMapVisibility)
      } else {
        const newMissionMapVisibility = (
          context.rootGetters.modifiedAdmMissionGlobal.misIdArray as Array<number>
        ).reduce((a, misId) => {
          a[misId] = false
          return a
        }, {} as { [id: number]: boolean })
        context.commit(types.UI_HIDE_ALL_DRAWER_MISSION_MAP, { newMissionMapVisibility, uiid: '' })
      }
      resolve()
    })
  }
  public [types.UI_SHOW_ALL_DRAWER_MISSION_MAP](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      const newMissionMapVisibility =
        uiid == ''
          ? (context.rootGetters.drawerMissions as Array<AloMission>).reduce((a, item) => {
              a[item.misId!] = true
              return a
            }, {} as { [id: number]: boolean })
          : (context.rootGetters.currentDetailFleet.fleet.param?.missionIds as Array<number>).reduce((a, misId) => {
              a[misId] = true
              return a
            }, {} as { [id: number]: boolean })

      context.commit(types.UI_SHOW_ALL_DRAWER_MISSION_MAP, { newMissionMapVisibility, uiid })
      resolve()
    })
  }
  public [types.UI_HIDE_ALL_DRAWER_MISSION_MAP](context: ActionContext<IUiState, IRootState>, uiid: string) {
    const newMissionMapVisibility =
      uiid == ''
        ? (context.rootGetters.drawerMissions as Array<AloMission>).reduce((a, item) => {
            a[item.misId!] = false
            return a
          }, {} as { [id: number]: boolean })
        : (context.rootGetters.currentDetailFleet.fleet.param?.missionIds as Array<number>).reduce((a, misId) => {
            a[misId] = false
            return a
          }, {} as { [id: number]: boolean })
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_ALL_DRAWER_MISSION_MAP, { newMissionMapVisibility, uiid })
      resolve()
    })
  }

  public [types.UI_TOGGLE_SIMULATION_INFOS_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    { missionId }: { missionId: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      //lance la requete de chargement du détail d'une mission
      if (!(context.rootGetters.missionVirtualsById[missionId]?.mission?._detailLoaded ?? false)) {
        context.dispatch(types.MISSIONVIRTUAL_PROGRESSION_REQUEST, missionId)
      }
      context.commit(types.UI_TOGGLE_MISSION_INFOS_VISIBILITY, { missionId, uiid: '' })
      resolve()
    })
  }

  public [types.UI_TOGGLE_MISSION_INFOS_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    { missionId, uiid }: { missionId: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      //lance la requete de chargement du détail d'une mission
      const detailVisibility =
        uiid == ''
          ? context.getters.missionDetailVisibility
          : context.getters.uistatebyuiid(uiid).missionDetailVisibility
      if (!detailVisibility[missionId] && !context.rootGetters.missionsById[missionId]._detailLoaded) {
        context.dispatch(types.MISSION_LOADING_REQUEST, missionId)
      }
      context.commit(types.UI_TOGGLE_MISSION_INFOS_VISIBILITY, { missionId, uiid })
      resolve()
    })
  }

  public [types.UI_SELECT_MAP_BASELAYER](
    context: ActionContext<IUiState, IRootState>,
    { layer, uiid }: { layer: any; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SELECT_MAP_BASELAYER, { layer, uiid })
      resolve()
    })
  }
  public [types.UI_UNSELECT_MAP_BASELAYER](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_UNSELECT_MAP_BASELAYER, uiid)
      resolve()
    })
  }
  public [types.UI_CENTER_MAP](
    context: ActionContext<IUiState, IRootState>,
    { center, uiid }: { center: Coordinate; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_CENTER_MAP, { center, uiid })
      resolve()
    })
  }
  public [types.UI_ZOOM_MAP](
    context: ActionContext<IUiState, IRootState>,
    { zoom, uiid }: { zoom: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ZOOM_MAP, { zoom, uiid })
      resolve()
    })
  }
  public [types.UI_POS_MAP](
    context: ActionContext<IUiState, IRootState>,
    { center, zoom, uiid }: { center: Coordinate; zoom: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_POS_MAP, { center, zoom, uiid })
      resolve()
    })
  }
  public [types.UI_REFRESH_BEST_FIT_MAP](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_REFRESH_BEST_FIT_MAP, { uiid, bestFitMisId: -1 })
      resolve()
    })
  }
  public [types.UI_SELECT_TIMELINE_MISSION_INDEX](
    context: ActionContext<IUiState, IRootState>,
    { index, uiid }: { index: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SELECT_TIMELINE_MISSION_INDEX, { index, uiid })
      resolve()
    })
  }
  public [types.UI_SELECT_LAST_TIMELINE_MISSION_INDEX](context: ActionContext<IUiState, IRootState>, id: number) {
    return new Promise<void>((resolve, reject) => {
      const detailUiid = buildMissionUIStateId(id, 'detail')
      const globalUiid = buildMissionUIStateId(id, 'global')
      const fleetUiid = buildMissionUIStateId(id, 'fleet')
      const index = context.rootGetters.missionsById[id].yoArray.length - 1
      context.commit(types.UI_SELECT_TIMELINE_MISSION_INDEX, { index, uiid: detailUiid })
      context.commit(types.UI_SELECT_RANGETIMELINE_MISSION_INDEX, { range: [0, index], uiid: detailUiid })
      context.commit(types.UI_SELECT_TIMELINE_MISSION_INDEX, { index, uiid: globalUiid })
      context.commit(types.UI_SELECT_RANGETIMELINE_MISSION_INDEX, { range: [0, index], uiid: globalUiid })
      context.commit(types.UI_SELECT_TIMELINE_MISSION_INDEX, { index, uiid: fleetUiid })
      context.commit(types.UI_SELECT_RANGETIMELINE_MISSION_INDEX, { range: [0, index], uiid: fleetUiid })
      resolve()
    })
  }
  public [types.UI_REFRESH_NAV_GRAPH_CACHE](context: ActionContext<IUiState, IRootState>, id: number) {
    return new Promise<void>((resolve, reject) => {
      const detailUiid = buildMissionUIStateId(id, 'detail')
      const globalUiid = buildMissionUIStateId(id, 'global')
      const fleetUiid = buildMissionUIStateId(id, 'fleet')
      context.commit(types.UI_REFRESH_NAV_GRAPH_CACHE, detailUiid)
      context.commit(types.UI_REFRESH_NAV_GRAPH_CACHE, globalUiid)
      context.commit(types.UI_REFRESH_NAV_GRAPH_CACHE, fleetUiid)
      resolve()
    })
  }
  public [types.UI_REFRESH_SCI_GRAPH_CACHE](
    context: ActionContext<IUiState, IRootState>,
    { id, importedCsvHeaders }: { id: number; importedCsvHeaders: Array<string> | null },
  ) {
    return new Promise<void>((resolve, reject) => {
      const detailUiid = buildMissionUIStateId(id, 'detail')
      const globalUiid = buildMissionUIStateId(id, 'global')
      const fleetUiid = buildMissionUIStateId(id, 'fleet')
      context.commit(types.UI_REFRESH_SCI_GRAPH_CACHE, { uiid: detailUiid, importedCsvHeaders })
      context.commit(types.UI_REFRESH_SCI_GRAPH_CACHE, { uiid: globalUiid, importedCsvHeaders })
      context.commit(types.UI_REFRESH_SCI_GRAPH_CACHE, { uiid: fleetUiid, importedCsvHeaders })
      resolve()
    })
  }
  public [types.UI_SELECT_RANGETIMELINE_MISSION_INDEX](
    context: ActionContext<IUiState, IRootState>,
    { range, uiid }: { range: number[]; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SELECT_RANGETIMELINE_MISSION_INDEX, { range, uiid })
      resolve()
    })
  }
  public [types.UI_TOGGLE_HEADING_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_HEADING_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_HEADING](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_HEADING, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_HEADING](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_HEADING, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_OCEANCURRENT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_OCEANCURRENT, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_OCEANCURRENT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_OCEANCURRENT, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_OCEANCURRENT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_OCEANCURRENT, uiid)
      resolve()
    })
  }
  public [types.UI_SET_BORNE_MIN_CURRENT](
    context: ActionContext<IUiState, IRootState>,
    { min, uiid }: { min: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_BORNE_MIN_CURRENT, { min, uiid })
      resolve()
    })
  }
  public [types.UI_SET_BORNE_MAX_CURRENT](
    context: ActionContext<IUiState, IRootState>,
    { max, uiid }: { max: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_BORNE_MAX_CURRENT, { max, uiid })
      resolve()
    })
  }
  public [types.UI_SET_ZOOM_CURRENT](
    context: ActionContext<IUiState, IRootState>,
    { zoom, uiid }: { zoom: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_ZOOM_CURRENT, { zoom, uiid })
      resolve()
    })
  }
  public [types.UI_TOGGLE_DRIFT_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_DRIFT_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_DRIFT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_DRIFT, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_DRIFT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_DRIFT, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_MORE_NMEA_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MORE_NMEA_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_REMAINING_NAV_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_REMAINING_NAV_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_PATH_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_PATH_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_PATH](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_PATH, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_PATH](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_PATH, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_MISSIONPLAN_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MISSIONPLAN_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_MISSIONPLAN](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_MISSIONPLAN, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_MISSIONPLAN](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_MISSIONPLAN, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    uiid: string,
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_MISSIONPLAN_VALIDATION](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_MISSIONPLAN_VALIDATION, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_MISSIONPLAN_VALIDATION](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_MISSIONPLAN_VALIDATION, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_MISSIONLAYER_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MISSIONLAYER_VISIBILITY, uiid)
      resolve()
    })
  }

  public [types.UI_SET_MISSIONLAYERMAP_OPACITY](
    context: ActionContext<IUiState, IRootState>,
    { opacity, uiid }: { opacity: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_MISSIONLAYERMAP_OPACITY, { opacity, uiid })
      resolve()
    })
  }

  public [types.UI_SHOW_MISSIONLAYER](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_MISSIONLAYER, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_MISSIONLAYER](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_MISSIONLAYER, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_ENDMISSION_SIMULATION_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    uiid: string,
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_ENDMISSION_SIMULATION_VISIBILITY, uiid)
      resolve()
    })
  }

  public [types.UI_SET_ENDMISSION_SIMULATION_OPACITY](
    context: ActionContext<IUiState, IRootState>,
    { opacity, uiid }: { opacity: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_ENDMISSION_SIMULATION_OPACITY, { opacity, uiid })
      resolve()
    })
  }

  public [types.UI_SHOW_ENDMISSION_SIMULATION](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_ENDMISSION_SIMULATION, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_ENDMISSION_SIMULATION](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_ENDMISSION_SIMULATION, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_AIS_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_AIS_VISIBILITY, uiid)
      resolve()
    })
  }

  public [types.UI_TOGGLE_CYCLE_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_CYCLE_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_CYCLE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_CYCLE, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_CYCLE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_CYCLE, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_WAYPOINT_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_WAYPOINT_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_WAYPOINT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_WAYPOINT, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_WAYPOINT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_WAYPOINT, uiid)
      resolve()
    })
  }
  public async [types.UI_TOGGLE_LAYERMAP_VISIBILITY](
    context: ActionContext<IUiState, IRootState>,
    { layerId, uiid }: { layerId: number; uiid: string },
  ) {
    await context.commit(types.UI_SET_MEASURETOOL, 'NONE')
    context.commit(types.UI_TOGGLE_LAYERMAP_VISIBILITY, { layerId, uiid })
  }
  public [types.UI_SHOW_LAYERMAP](
    context: ActionContext<IUiState, IRootState>,
    { layerId, uiid }: { layerId: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_LAYERMAP, { layerId, uiid })
      resolve()
    })
  }
  public [types.UI_HIDE_LAYERMAP](
    context: ActionContext<IUiState, IRootState>,
    { layerId, uiid }: { layerId: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_LAYERMAP, { layerId, uiid })
      resolve()
    })
  }
  public [types.UI_SET_LAYERMAP_OPACITY](
    context: ActionContext<IUiState, IRootState>,
    { layerId, opacity, uiid }: { layerId: number; opacity: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_LAYERMAP_OPACITY, { layerId, opacity, uiid })
      resolve()
    })
  }
  public [types.UI_SET_LAYERMAP_CONFIG](
    context: ActionContext<IUiState, IRootState>,
    { layerId, config, uiid }: { layerId: number; config: LayerConfig; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_LAYERMAP_CONFIG, { layerId, config, uiid })
      resolve()
    })
  }
  public [types.UI_SELECT_MISSION_MAP](
    context: ActionContext<IUiState, IRootState>,
    { id, uiid }: { id: number | null; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      //si l'action est pour la map global on selectionne la mission courante
      if (uiid == 'map_global') {
        //on charge le detail de la mission au besoin
        if (
          id &&
          (!context.getters.missionDetailVisibility[id] || !context.rootGetters.missionsById[id]._detailLoaded)
        ) {
          context.dispatch(types.MISSION_LOADING_REQUEST, id)
        }
        context.commit(types.UI_SELECT_MISSION_MAP, id)
      }
      if (uiid == '') {
        //recherche les cartes ouverte et centre le glider en fonction de sa position
        if (context.rootState.mission.currentDetailMission.tabsleft.selected.indexOf('MissionDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.mission.currentDetailMission.tabsleft.selected,
            bestFitMisId: id,
          })
        }
        if (context.rootState.mission.currentDetailMission.tabsright.selected.indexOf('MissionDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.mission.currentDetailMission.tabsright.selected,
            bestFitMisId: id,
          })
        }
        if (context.rootState.fleet.currentDetailFleet.tabsleft.selected.indexOf('FleetDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.fleet.currentDetailFleet.tabsleft.selected,
            bestFitMisId: id,
          })
        }
        if (context.rootState.fleet.currentDetailFleet.tabsright.selected.indexOf('FleetDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.fleet.currentDetailFleet.tabsright.selected,
            bestFitMisId: id,
          })
        }
      } else {
        //centre la carte sur le glider en fonction de sa position
        context.commit(types.UI_REFRESH_BEST_FIT_MAP, { uiid, bestFitMisId: id })
      }
      resolve()
    })
  }
  public [types.UI_SELECT_SIMULATION_MAP](
    context: ActionContext<IUiState, IRootState>,
    { id, uiid }: { id: number; uiid: string },
  ) {
    context.commit(types.UI_SELECT_SIMULATION_MAP, id)
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_REFRESH_BEST_FIT_MAP, { uiid, bestFitMisId: id })
    })
  }
  public [types.UI_SELECT_FLEET_MAP](
    context: ActionContext<IUiState, IRootState>,
    { id, uiid }: { id: number; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      //si l'action est pour la map global on selectionne la flotte courante
      if (uiid == 'map_global') {
        //on charge le detail des flottes au besoin
        if (!context.getters.missionDetailVisibility[id] && !context.rootGetters.missionsById[id]._detailLoaded) {
          context.dispatch(types.MISSION_LOADING_REQUEST, id)
        }
        context.commit(types.UI_SELECT_MISSION_MAP, id)
      }
      if (uiid == '') {
        //recherche les cartes ouverte et centre le glider en fonction de sa position
        if (context.rootState.fleet.currentDetailFleet.tabsleft.selected.indexOf('FleetDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.fleet.currentDetailFleet.tabsleft.selected,
            bestFitMisId: -1,
          })
        }
        if (context.rootState.fleet.currentDetailFleet.tabsright.selected.indexOf('FleetDetailMap') == 0) {
          context.commit(types.UI_REFRESH_BEST_FIT_MAP, {
            uiid: context.rootState.fleet.currentDetailFleet.tabsright.selected,
            bestFitMisId: -1,
          })
        }
      } else {
        //centre la carte sur le glider en fonction de sa position
        context.commit(types.UI_REFRESH_BEST_FIT_MAP, { uiid, bestFitMisId: -1 })
      }
      resolve()
    })
  }
  public [types.UI_SET_ITEM_MAP_STYLE](
    context: ActionContext<IUiState, IRootState>,
    { style, uiid, colorType, mapUiid }: { style: any; uiid: string; colorType: string; mapUiid?: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      //recherche les uiid des cartes a mettre à jour
      const map_uiids = mapUiid ? [mapUiid] : []
      //si mode global on met à jour la map principale
      if (context.state.uistates[uiid].typeUiid == 'global' && mapUiid != 'map_global') map_uiids.push('map_global')
      else {
        //sinon on regarde si le composant sélectionné est la carte
        if (context.rootState.mission.currentDetailMission.tabsleft.selected.indexOf('MissionDetailMap') == 0)
          map_uiids.push(context.rootState.mission.currentDetailMission.tabsleft.selected)
        if (context.rootState.mission.currentDetailMission.tabsright.selected.indexOf('MissionDetailMap') == 0)
          map_uiids.push(context.rootState.mission.currentDetailMission.tabsright.selected)
        if (context.rootState.fleet.currentDetailFleet.tabsleft.selected.indexOf('FleetDetailMap') == 0)
          map_uiids.push(context.rootState.fleet.currentDetailFleet.tabsleft.selected)
        if (context.rootState.fleet.currentDetailFleet.tabsright.selected.indexOf('FleetDetailMap') == 0)
          map_uiids.push(context.rootState.fleet.currentDetailFleet.tabsright.selected)
      }
      context.commit(types.UI_SET_ITEM_MAP_STYLE, { style, uiid, colorType, map_uiids })
      resolve()
    })
  }
  public [types.UI_SET_DEFAULT_MAP_STYLE](
    context: ActionContext<IUiState, IRootState>,
    { style, uiid }: { style: string; uiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_DEFAULT_MAP_STYLE, { style, uiid })
      resolve()
    })
  }
  public [types.UI_SET_GRA_ABSCISSE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, abscisse }: { uiid: string; abscisse: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_ABSCISSE, { uiid, abscisse })
      resolve()
    })
  }
  public [types.UI_SET_GRA_ORDONNEE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, ordonnee }: { uiid: string; ordonnee: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_ORDONNEE, { uiid, ordonnee })
      resolve()
    })
  }
  public [types.UI_SET_GRA_COLOR](
    context: ActionContext<IUiState, IRootState>,
    { uiid, color }: { uiid: string; color: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_COLOR, { uiid, color })
      resolve()
    })
  }
  public [types.UI_SET_GRA_TRANSFORM](
    context: ActionContext<IUiState, IRootState>,
    { uiid, transform }: { uiid: string; transform: ZoomTransform },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_TRANSFORM, { uiid, transform })
      resolve()
    })
  }
  public [types.UI_SET_GRA_ZOOM](
    context: ActionContext<IUiState, IRootState>,
    { uiid, zoom }: { uiid: string; zoom: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_ZOOM, { uiid, zoom })
      resolve()
    })
  }
  public [types.UI_SET_GRA_DATA](
    context: ActionContext<IUiState, IRootState>,
    { uiid, name, value }: { uiid: string; name: string; value: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_DATA, { uiid, name, value })
      resolve()
    })
  }
  public [types.UI_SET_SCI_HOVERDATA](
    context: ActionContext<IUiState, IRootState>,
    { uiid, hoverData }: { uiid: string; hoverData: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_SCI_HOVERDATA, { uiid, hoverData })
      resolve()
    })
  }
  public [types.UI_SET_NAV_HOVERDATA](
    context: ActionContext<IUiState, IRootState>,
    { uiid, hoverData }: { uiid: string; hoverData: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_NAV_HOVERDATA, { uiid, hoverData })
      resolve()
    })
  }
  public [types.UI_SET_SIMU_HOVERDATA](
    context: ActionContext<IUiState, IRootState>,
    { uiid, hoverData }: { uiid: string; hoverData: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_SIMU_HOVERDATA, { uiid, hoverData })
      resolve()
    })
  }
  public [types.UI_SET_GRA_POINT_SIZE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, size }: { uiid: string; size: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_POINT_SIZE, { uiid, size })
      resolve()
    })
  }
  public [types.UI_SAVE_CHART_CONFIG](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SAVE_CHART_CONFIG, uiid)
      resolve()
    })
  }
  public [types.UI_TOGGLE_GRA_VORONOI](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_GRA_VORONOI, uiid)
      resolve()
    })
  }
  public [types.UI_SET_GRA_CONFIG](
    context: ActionContext<IUiState, IRootState>,
    { uiid, config }: { uiid: string; config: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_CONFIG, { uiid, config })
      resolve()
    })
  }
  public [types.UI_SET_NMEA_GRA_CONFIG](
    context: ActionContext<IUiState, IRootState>,
    { uiid, config }: { uiid: string; config: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_NMEA_GRA_CONFIG, { uiid, config })
      resolve()
    })
  }
  public [types.UI_SET_SIMULATION_GRA_TYPE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, type }: { uiid: string; type: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_SIMULATION_GRA_TYPE, { uiid, type })
      resolve()
    })
  }

  public [types.UI_SET_GRA_STATE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, config }: { uiid: string; config: GraphUiState },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRA_STATE, { uiid, config })
      resolve()
    })
  }
  public [types.UI_SET_COORDFORMATER](context: ActionContext<IUiState, IRootState>, formater: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_COORDFORMATER, formater)
      resolve()
    })
  }
  public [types.UI_SET_MEASURETOOL](context: ActionContext<IUiState, IRootState>, tool: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_MEASURETOOL, tool)
      resolve()
    })
  }
  public [types.UI_TOGGLE_ONGOING_MISSION_VIEW](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_ONGOING_MISSION_VIEW)
      resolve()
    })
  }
  public [types.UI_ACTIVE_ONGOING_MISSION_VIEW](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ACTIVE_ONGOING_MISSION_VIEW)
      if (context.rootGetters.allMissionVisibility) context.dispatch(types.UI_SHOW_ALL_DRAWER_MISSION_MAP, '')
      else context.dispatch(types.UI_HIDE_ALL_DRAWER_MISSION_MAP, '')
      resolve()
    })
  }
  public [types.UI_ACTIVE_SIMULATED_MISSION_VIEW](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ACTIVE_SIMULATED_MISSION_VIEW)
      resolve()
    })
  }
  public [types.UI_UNACTIVE_ONGOING_MISSION_VIEW](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_UNACTIVE_ONGOING_MISSION_VIEW)
      if (context.rootGetters.allMissionVisibility) context.dispatch(types.UI_SHOW_ALL_DRAWER_MISSION_MAP, '')
      else context.dispatch(types.UI_HIDE_ALL_DRAWER_MISSION_MAP, '')
      resolve()
    })
  }
  public [types.UI_UNACTIVE_SIMULATED_MISSION_VIEW](context: ActionContext<IUiState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_UNACTIVE_SIMULATED_MISSION_VIEW)
      resolve()
    })
  }
  public [types.UI_TOGGLE_GRATICULE_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_GRATICULE_VISIBILITY, uiid)
      resolve()
    })
  }
  public [types.UI_SHOW_GRATICULE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SHOW_GRATICULE, uiid)
      resolve()
    })
  }
  public [types.UI_HIDE_GRATICULE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_HIDE_GRATICULE, uiid)
      resolve()
    })
  }
  public [types.UI_SET_MOVABLE_DIALOG_VISIBILITY](context: ActionContext<IUiState, IRootState>, isVisible: boolean) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_MOVABLE_DIALOG_VISIBILITY, isVisible)
      resolve()
    })
  }
  public [types.UI_SHOW_DEPTH_PROFILE_DIALOG](context: ActionContext<IUiState, IRootState>, feature: Feature) {
    return new Promise<void>((resolve, reject) => {
      //lance la requete de recherche du depth profile
      context.dispatch(types.LAYERMAP_DEPTH_PROFILE_REQUEST, feature)
      //affiche la fenetre de resultat
      context.commit(types.UI_SHOW_DEPTH_PROFILE_DIALOG)
      resolve()
    })
  }
  public [types.UI_SHOW_CHART_CONFIG_DIALOG](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      //affiche la fenetre de resultat
      context.commit(types.UI_SHOW_CHART_CONFIG_DIALOG, uiid)
      resolve()
    })
  }
  public [types.UI_ENSURE_MISSION_STATE](
    context: ActionContext<IUiState, IRootState>,
    { ids, typeUiid }: { ids: number[]; typeUiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_MISSION_STATE, { ids, typeUiid })
      resolve()
    })
  }
  public [types.UI_ENSURE_MISSIONGLOBAL_STATE](
    context: ActionContext<IUiState, IRootState>,
    { ids, typeUiid }: { ids: number[]; typeUiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_MISSIONGLOBAL_STATE, { ids, typeUiid })
      resolve()
    })
  }
  public [types.UI_ENSURE_FLEET_STATE](
    context: ActionContext<IUiState, IRootState>,
    { ids, typeUiid }: { ids: number[]; typeUiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_FLEET_STATE, { ids, typeUiid })
      resolve()
    })
  }
  public [types.UI_ENSURE_MISSIONPLAN_STATE](
    context: ActionContext<IUiState, IRootState>,
    { id, typeUiid }: { id: number; typeUiid: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_MISSIONPLAN_STATE, { id, typeUiid })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_HOVER_WPT_ID](
    context: ActionContext<IUiState, IRootState>,
    { uiid, wptId }: { uiid: string; wptId: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_HOVER_WPT_ID, { uiid, wptId })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_HOVER_STEP_ID](
    context: ActionContext<IUiState, IRootState>,
    { uiid, stepId }: { uiid: string; stepId: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_HOVER_STEP_ID, { uiid, stepId })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_HOVER_PRF_ID](
    context: ActionContext<IUiState, IRootState>,
    { uiid, prfId }: { uiid: string; prfId: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_HOVER_PRF_ID, { uiid, prfId })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL](
    context: ActionContext<IUiState, IRootState>,
    { uiid, prf }: { uiid: string; prf: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL, { uiid, prf })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL_SCI](
    context: ActionContext<IUiState, IRootState>,
    { uiid, prf }: { uiid: string; prf: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL_SCI, { uiid, prf })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_CURRENT_EDIT_STEP](
    context: ActionContext<IUiState, IRootState>,
    { uiid, step }: { uiid: string; step: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_CURRENT_EDIT_STEP, { uiid, step })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT](
    context: ActionContext<IUiState, IRootState>,
    { uiid, wpt }: { uiid: string; wpt: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT, { uiid, wpt })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_CURRENT_EDIT_SENSOR](
    context: ActionContext<IUiState, IRootState>,
    { uiid, sensor }: { uiid: string; sensor: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_CURRENT_EDIT_SENSOR, { uiid, sensor })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_DRAWMOD](
    context: ActionContext<IUiState, IRootState>,
    { uiid, drawmode }: { uiid: string; drawmode: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_DRAWMOD, { uiid, drawmode })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_SHOW_GLOBALWPT](
    context: ActionContext<IUiState, IRootState>,
    { uiid, show }: { uiid: string; show: boolean },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_SHOW_GLOBALWPT, { uiid, show })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_LASTACTION_ID](
    context: ActionContext<IUiState, IRootState>,
    { uiid, actId }: { uiid: string; actId: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_LASTACTION_ID, { uiid, actId })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_SHOWALL_VALIDATION](
    context: ActionContext<IUiState, IRootState>,
    { uiid, show }: { uiid: string; show: boolean },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_SHOWALL_VALIDATION, { uiid, show })
      resolve()
    })
  }
  public [types.UI_MISSIONPLAN_SET_MISSIONPLAN](
    context: ActionContext<IUiState, IRootState>,
    { uiid, plan }: { uiid: string; plan: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MISSIONPLAN_SET_MISSIONPLAN, { uiid, plan })
      resolve()
    })
  }
  public [types.UI_ENSURE_GRA_STATE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, config }: { uiid: string; config: any },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_GRA_STATE, { uiid, config })
      resolve()
    })
  }
  public [types.UI_ENSURE_ALL_GRA_STATE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_ALL_GRA_STATE, uiid)
      resolve()
    })
  }
  public [types.UI_ENSURE_MAP_STATE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_MAP_STATE, uiid)
      resolve()
    })
  }
  public [types.UI_ENSURE_FLEETMAP_STATE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_ENSURE_FLEETMAP_STATE, uiid)
      resolve()
    })
  }
  public [types.UI_ENABLE_CONSOLE_MSG](context: ActionContext<IUiState, IRootState>, id: number) {
    return new Promise<void>((resolve, reject) => {
      const uiid = buildMissionUIStateId(id, 'detail')
      if (!context.getters.uistatebyuiid(uiid).canLogConsoleMsg) {
        context.commit(types.UI_ENABLE_CONSOLE_MSG, uiid)
        context.dispatch(types.UI_LOAD_CONSOLE_MSG_REQUEST, { id, nb: 50 }).finally(() => {          
          resolve()
        })
      } else {
        resolve()
      }
    })
  }
  public [types.UI_LOAD_CONSOLE_MSG_REQUEST](
    context: ActionContext<IUiState, IRootState>,
    { id, stop, nb }: { id: number; stop: number; nb: number | undefined },
  ) {
    context.commit(types.UI_LOAD_CONSOLE_MSG_REQUEST, id)
    //console.log("UI_LOAD_CONSOLE_MSG_REQUEST",{id,stop,nb})
    return new Promise((resolve, reject) => {
      apiMission
        .getGospAsConsoleRow({ id, nb, stop })
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const rows = resp.data.data as Array<ConsoleRow>
            context.commit(types.UI_LOAD_CONSOLE_MSG_SUCCESS, { id, rows })
            resolve(rows)
          } else {
            context.commit(types.UI_LOAD_CONSOLE_MSG_ERROR, id)
            reject()
          }
        })
        .catch(() => {
          context.commit(types.UI_LOAD_CONSOLE_MSG_ERROR, id)
          reject()
        })
    })
  }
  public [types.UI_RESET_UISTATE](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_RESET_UISTATE, uiid)
      resolve()
    })
  }
  public [types.UI_REFRESH_COMPONENT](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_REFRESH_COMPONENT, uiid)
      resolve()
    })
  }
  public [types.UI_SET_INFOS_DIALOG_VISIBILITY](context: ActionContext<IUiState, IRootState>, isVisible: boolean) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_INFOS_DIALOG_VISIBILITY, isVisible)
      resolve()
    })
  }
  public [types.UI_SHOW_INFOS_DIALOG](
    context: ActionContext<IUiState, IRootState>,
    { title, infos, urlinfos }: { title: string; infos: string; urlinfos: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      //affiche la fenetre de resultat
      context.commit(types.UI_SHOW_INFOS_DIALOG, { title, infos, urlinfos })
      resolve()
    })
  }
  public [types.UI_SET_KEYPRESS](
    context: ActionContext<IUiState, IRootState>,
    { code, pressed }: { code: string; pressed: boolean },
  ) {
    return new Promise<void>((resolve, reject) => {
      //affiche la fenetre de resultat
      context.commit(types.UI_SET_KEYPRESS, { code, pressed })
      resolve()
    })
  }
  public [types.UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY](context: ActionContext<IUiState, IRootState>, uiid: string) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY, uiid)
      resolve()
    })
  }

  public [types.UI_SET_PLANIFVIEW_MODE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, mode }: { uiid: string; mode: string },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_PLANIFVIEW_MODE, { uiid, mode })
      resolve()
    })
  }

  public [types.UI_SET_GRAPH_HOVER_DATA](context: ActionContext<IUiState, IRootState>, graphHover: HoverData) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRAPH_HOVER_DATA, graphHover)
      resolve()
    })
  }

  public [types.UI_SET_GRAPH_HOVER_DATA_VISIBILITY](context: ActionContext<IUiState, IRootState>, visible: boolean) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_SET_GRAPH_HOVER_DATA_VISIBILITY, visible)
      resolve()
    })
  }

  public [types.UI_SET_LEFTPANEL_SIZE](
    context: ActionContext<IUiState, IRootState>,
    { uiid, size }: { uiid: string; size: string },
  ) {
    context.commit(types.UI_SET_LEFTPANEL_SIZE, { uiid, size })
  }

  public [types.UI_NAVTO_DETAIL](
    context: ActionContext<IMissionState, IRootState>,
    { uiid, cmp, isleft, id, label }: { uiid: string; cmp: string; isleft: boolean; id: number; label: string },
  ) {
    context.dispatch(types.UI_SET_MEASURETOOL, 'NONE')
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_NAVTO_DETAIL, { uiid, cmp, isleft, id, label })
      resolve()
    })
  }

  public [types.UI_UNSELECT_TAB](
    context: ActionContext<IUiState, IRootState>,
    { uiid, cmp, isleft, id }: { uiid: string; cmp: string; isleft: boolean; id: number },
  ) {
    if (context.state.uistates.hasOwnProperty(uiid)) {
      const detailPanelState = context.state.uistates[uiid] as SimulationUiState
      const tabsUI = isleft ? detailPanelState.tabsleft : detailPanelState.tabsright
      const tab = tabsUI.tabs.find(it => it.cmp == cmp && it.id == id)
      if (tab && tab.checkBeforeClose) {
        context.commit(types.UI_UNSELECT_TAB, tab)
      } else {
        context.dispatch(types.UI_CLOSE_TAB, { uiid, cmp, isleft, id })
      }
    }
  }

  public [types.UI_CLOSE_TAB](
    context: ActionContext<IUiState, IRootState>,
    { uiid, cmp, isleft, id }: { uiid: string; cmp: string; isleft: boolean; id: number },
  ) {
    context.commit(types.UI_CLOSE_TAB, { uiid, cmp, isleft, id })
    context.dispatch(types.UI_RESET_UISTATE, `${cmp}-${id}`)
  }

  public [types.UI_RENAME_DETAIL](
    context: ActionContext<IUiState, IRootState>,
    { uiid, cmp, isleft, id, label }: { uiid: string; cmp: string; isleft: boolean; id: number; label: string },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.UI_RENAME_DETAIL, { uiid, cmp, isleft, id, label })
      resolve(label)
    })
  }

  public [types.UI_MOVE_TAB](
    context: ActionContext<IUiState, IRootState>,
    { uiid, cmp, isleft, id }: { uiid: string; cmp: string; isleft: boolean; id: number },
  ) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.UI_MOVE_TAB, { uiid, cmp, isleft, id })
      resolve()
    })
  }

  public [types.UI_FLEET_LOGBOOK_REQUEST](context: ActionContext<IUiState, IRootState>, id: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.UI_FLEET_LOGBOOK_REQUEST, id)
      apiAdminAdminFleet
        .getLogbook(id)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const datas = (resp.data.data as AloLogbookChannel).messageArray
            //context.commit les données de la fleet
            context.commit(types.UI_FLEET_LOGBOOK_SUCCESS, { id, datas })
            resolve(datas)
          } else {
            context.commit(types.UI_FLEET_LOGBOOK_ERROR, id)
            reject()
          }
        })
        .catch(error => {
          context.commit(types.UI_FLEET_LOGBOOK_ERROR, id)
          reject()
        })
    })
  }

  public [types.UI_FLEET_LOGBOOK_ITEM_REQUEST](
    context: ActionContext<IUiState, IRootState>,
    { fleId, logBookId }: { fleId: number; logBookId: number },
  ) {
    return new Promise((resolve, reject) => {
      //on ne lance la requete d'un item que si le logBook est chargé
      const fleetState = context.rootGetters.uistatebyuiid(buildFleetUIStateId(fleId, 'detail'))
      if (fleetState !== undefined && fleetState._logBookLoaded) {
        context.commit(types.UI_FLEET_LOGBOOK_ITEM_REQUEST, { fleId, logBookId })
        apiMission
          .getLogbookItem(logBookId)
          .then(resp => {
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const data = resp.data.data as AloLogbookItem
              //context.commit les données de la mission
              context.commit(types.UI_FLEET_LOGBOOK_ITEM_SUCCESS, { fleId, data })
              resolve(data)
            } else {
              context.commit(types.UI_FLEET_LOGBOOK_ITEM_ERROR, { fleId, logBookId })
              reject()
            }
          })
          .catch(error => {
            context.commit(types.MISSION_LOGBOOK_ITEM_ERROR, { fleId, logBookId })
            reject()
          })
      } else {
        resolve(null)
      }
    })
  }

  public [types.UI_FLEET_LOGBOOK_SEND_MESSAGE_REQUEST](
    context: ActionContext<IUiState, IRootState>,
    { fleId, message }: { fleId: number; message: string },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.UI_FLEET_LOGBOOK_SEND_MESSAGE_REQUEST, fleId)
      apiAdminAdminFleet
        .addMessageToLogbook({ fleId, message })
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const data = resp.data.data as AloLogbookItem
            //context.commit les données de la fleet
            context.commit(types.UI_FLEET_LOGBOOK_ITEM_SUCCESS, { fleId, data })
            resolve(data)
          } else {
            context.commit(types.UI_FLEET_LOGBOOK_SEND_MESSAGE_ERROR, fleId)
            reject()
          }
        })
        .catch(error => {
          context.commit(types.UI_FLEET_LOGBOOK_SEND_MESSAGE_ERROR, fleId)
          reject()
        })
    })
  }

  public [types.UI_FLEET_LOGBOOK_UPDATE_MESSAGE_REQUEST](
    context: ActionContext<IUiState, IRootState>,
    { fleId, lbkId, message }: { fleId: number; lbkId: number; message: string },
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.UI_FLEET_LOGBOOK_UPDATE_MESSAGE_REQUEST, lbkId)
      apiMission
        .updateMessageToLogbook({ lbkId, message })
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const data = resp.data.data as AloLogbookItem
            //context.commit les données de la mission
            context.commit(types.UI_FLEET_LOGBOOK_ITEM_SUCCESS, { fleId, data })
            resolve(data)
          } else {
            context.commit(types.UI_FLEET_LOGBOOK_UPDATE_MESSAGE_ERROR, { fleId, lbkId })
            reject()
          }
        })
        .catch(error => {
          context.commit(types.UI_FLEET_LOGBOOK_UPDATE_MESSAGE_ERROR, { fleId, lbkId })
          reject()
        })
    })
  }
}

export default util.classToObject(UiAction)
